
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `將其加入主屏幕，以獲得更豐富的體驗和便捷訪問。`,
's224cbcec014ef6b5': `點擊列表上的分享按鈕`,
's37a9e8aec5713460': `詳細資訊`,
's386eca8362ff6155': `如果沒有分享圖標，請點擊更多`,
's4e1e10a6ca408245': `點擊「添加到主屏幕」`,
's6196153c4b0c1ea0': `安裝`,
's633502f7cff4f847': `打開您的瀏覽器菜單`,
's681e399d63311fba': `顯示圖庫`,
's7f0591f08e318eda': `在分享菜單中點擊更多`,
's8114bd55cae5a22b': `點選添加到Dock欄`,
's922329d6f6213590': `添加到Dock欄`,
's9af56bf005b49c74': `向下滾動到「添加到主屏幕」`,
'sa5ef80b4bb9b39f8': `簡短資訊`,
'sba52286c21552a4e': `在您的裝置上安裝它，以獲得更豐富的體驗和便捷訪問。`,
'sc16e00a7a8b2fde2': `返回`,
'scdaf4bbff76674c8': `將App加入主畫面`,
'se0e473adfda8066c': `在您的主要瀏覽器中打開`,
'se740f75b95a51807': `將其加入你的Dock欄，以獲得更豐富的體驗和便捷訪問。`,
'sfea652f6580ff086': `此網站具有應用程式功能。`,
    };
  